import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import * as Urls from 'src/constants/EndpointUrls';
import Button from 'jbc-front/components/Button';
import {
  takeBonusConfirmedStateFromSearchForm,
  takeBonusFromSearchForm,
  takeBonusesQueriedUrl,
  takeBonusesFbDataUrl,
  FORM_NAME_BONUSES_SEARCH
} from 'src/reducers/searchForm';
import DownloadBonusReports from 'src/features/EmployeeBonus/containers/DownloadBonusReportsContainer';
import EmployeeBonusMethod from './EmployeeBonusMethod';
import AllowanceDeductionsMethod from './AllowanceDeductionsMethod';
import styles from './ExtraActionsSection.scss';
import { withTranslation } from 'react-i18next';

class ExtraActionsSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isBonusBaloonOpen: false,
      isAllowanceDeductionsOpen: false
    };
  }

  render() {
    const {
      confirmed,
      downloadTemplateCsvPageUrl,
      showBonusFbDataUrl,
      currentBonus,
      clientBonusId,
      isConfirmed
    } = this.props;
    return (
      <div className={styles.wrap}>
        <div className={styles.button}>
          <Button
            widthAuto
            className="ignore-react-onclickoutside"
            onClick={() =>
              this.setState({
                isAllowanceDeductionsOpen: !this.state.isAllowanceDeductionsOpen,
                isBonusBaloonOpen: false
              })
            }
          >
            {this.props.t('features.EmployeeBonus.components.ExtraActionsSection.Provision_and_deduction_items')}
          </Button>
          {this.state.isAllowanceDeductionsOpen && (
            <AllowanceDeductionsMethod
              hide={() => this.setState({ isAllowanceDeductionsOpen: false })}
              downloadTemplateCsvPageUrl={downloadTemplateCsvPageUrl}
              currentBonus={currentBonus}
              confirmed={confirmed}
            />
          )}
        </div>
        <div className={styles.button}>
          <Button
            widthAuto
            disabled={!confirmed}
            className="ignore-react-onclickoutside"
            onClick={() =>
              this.setState({ isBonusBaloonOpen: !this.state.isBonusBaloonOpen, isAllowanceDeductionsOpen: false })
            }
          >
            {this.props.t('features.EmployeeBonus.components.ExtraActionsSection.Bonus_transfer')}
          </Button>
          <EmployeeBonusMethod
            hide={() => this.setState({ isBonusBaloonOpen: false })}
            showBonusFbDataUrl={showBonusFbDataUrl}
            confirmed={confirmed}
            isOpen={this.state.isBonusBaloonOpen}
          />
        </div>
        <DownloadBonusReports clientBonusId={clientBonusId} isConfirmed={isConfirmed} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  confirmed: takeBonusConfirmedStateFromSearchForm(state),
  downloadTemplateCsvPageUrl: takeBonusesQueriedUrl(
    Urls.EMPLOYEE_BONUS_DOWNLOAD_CSV_PAGE_URL,
    getFormValues(FORM_NAME_BONUSES_SEARCH)(state)
  ),
  showBonusFbDataUrl: takeBonusesFbDataUrl(getFormValues(FORM_NAME_BONUSES_SEARCH)(state)),
  currentBonus: takeBonusFromSearchForm(state)
});
export default withTranslation('translation')(connect(mapStateToProps)(ExtraActionsSection));
